import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchTeamStats } from '@api-service/team-stats';
import type {
  GetTeamStatsOptions,
  TeamStatsResponse
} from '@api-service/team-stats';

export type UseTeamStatsOptions = Omit<GetTeamStatsOptions, 'cursor'> & {
  enabled?: boolean;
  staleTime?: number;
};

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const useTeamStats = ({
  enabled = true,
  staleTime = FIVE_MINUTES_IN_MS,
  ...options
}: UseTeamStatsOptions) =>
  useInfiniteQuery<TeamStatsResponse, Error>({
    queryKey: [
      'team-stats',
      options.accessToken ? 'auth' : 'anon',
      options.fields,
      options.aggregation,
      options.venue,
      options.season,
      options.minGameweek,
      options.maxGameweek,
      options.minDifficulty,
      options.maxDifficulty,
      options.sortBy,
      options.sortDirection,
      options.limit
    ],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      fetchTeamStats({ ...options, cursor: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.meta?.hasMore
        ? lastPage.meta.nextCursor ?? undefined
        : undefined,
    keepPreviousData: true,
    enabled,
    staleTime
  });
